import axios from 'axios';

import { DeveloperPreview, EligibilityCriteria, ExperimentEligibilityCriteria } from './types';

const agent = axios.create();

export const fetchDeveloperPreviews = () => agent.get<DeveloperPreview[]>('/previews').then(res => res.data);

export const fetchFeatureFlagAssignments = <T extends string, U extends string = 'on' | 'off'>(
  featureFlags: T[],
  eligibilityCriteria: EligibilityCriteria,
) =>
  agent
    .post<Record<T, U | null>>('/regatta/generic/feature_flag/assignments', {
      feature_flags: featureFlags,
      eligibility_criteria: eligibilityCriteria,
    })
    .then(res => res.data);

export const fetchExperimentAssignments = (
  experimentNames: string[],
  eligibilityCriteria: ExperimentEligibilityCriteria,
) =>
  agent
    .post('/regatta/merchant/assignments', {
      experiment_names: experimentNames,
      eligibility_criteria: eligibilityCriteria,
    })
    .then(res => res.data);

export default agent;
